module.exports = __webpack_public_path__ + "img/CalendarPlus.b0fd8da7.svg";